import PhoneInputV1 from "../../../../components/form_builder/elements/phone_input/PhoneInputV1.vue";
import {
  validateRequired,
  validatePhoneNumber
} from "../../../../helpers/validation";

export default {
  componentName: "fb-phone-input-v1",
  component: PhoneInputV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      placeholder: "Write something...",
      description: "",
      value: "",
      required: false,
      hidden: false,
      readonly: false,
      style: {},
      eFormEditable: true
    }
  },
  gridAttrs: {
    type: "template",
    width: 150,
    template: ({ value }) => value
  },
  getValueReport: value => {
    return value;
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    if (validateRequired(value) && !validatePhoneNumber(value))
      errors.push("Invalid phone number");
    return errors;
  }
};
